/**
 * DALinearRegressionService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DALinearRegressionService {
    getLinearRegressionData = (body) => {
        return apiClient.post("/dataAnalysis/lregression", body);
    }
}
